import {
  PRIVACY_CONSENT_EVENT,
  PRIVACY_CONSENT_KEY,
  clearPrivacyConsent,
  getPrivacyConsent,
  setAnalyticsConsent,
} from "@/lib/privacyConsent";

export const COOKIE_CONSENT_KEY = PRIVACY_CONSENT_KEY;
export const COOKIE_CONSENT_EVENT = PRIVACY_CONSENT_EVENT;

export const COOKIE_CONSENT = {
  NECESSARY: "necessary",
  ALL: "all",
};

export function getCookieConsent() {
  const consent = getPrivacyConsent();
  if (!consent.analyticsDecided) return null;
  return consent.analyticsEnabled ? COOKIE_CONSENT.ALL : COOKIE_CONSENT.NECESSARY;
}

export function setCookieConsent(value, source = null) {
  if (typeof window === "undefined") return;
  if (value !== COOKIE_CONSENT.NECESSARY && value !== COOKIE_CONSENT.ALL) return;
  setAnalyticsConsent(value === COOKIE_CONSENT.ALL, source);
}

export function clearCookieConsent() {
  if (typeof window === "undefined") return;
  clearPrivacyConsent();
}

export function hasCookieConsentChoice() {
  return getCookieConsent() != null;
}

export function allowsOptionalStorage() {
  return getCookieConsent() === COOKIE_CONSENT.ALL;
}
